import { render } from "./PlayStore.vue?vue&type=template&id=3876b58a&lang=pug"
import script from "./PlayStore.vue?vue&type=script&lang=js"
export * from "./PlayStore.vue?vue&type=script&lang=js"

import exportComponent from "/home/apognu/code/personal/defcon/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__